import React, { useEffect, useRef, useState } from 'react'
import { Modal, TextInput, TouchableWithoutFeedback } from 'react-native'
import styled from 'styled-components/native'
import { Button } from 'ui/common/button.tsx'
import { ColumnLayout, RowLayout } from 'ui/common/layout.tsx'
import { Body1, Body2, H2 } from 'ui/common/text.tsx'
import { CustomTextInput } from 'ui/common/custom-text-input.tsx'
import { colors } from 'infra/color.ts'
import { ButtonShadow } from 'ui/home/bottom-button-styles.ts'

export const CustomPrompt: React.FC<{
  isVisible: boolean
  onConfirm: (inputText: string, setInputText: (v: string) => void) => void
  onCancel: () => void
}> = ({ isVisible, onConfirm, onCancel }) => {
  const [inputText, setInputText] = useState('')
  const inputRef = useRef<TextInput | null>(null)
  useEffect(() => {
    if (isVisible) {
      setTimeout(() => {
        inputRef?.current?.focus()
      }, 100)
    }
  }, [isVisible])
  return (
    <Modal visible={isVisible} transparent>
      <TouchableWithoutFeedback onPress={() => onCancel()}>
        <ModalBackground>
          <TouchableWithoutFeedback>
            <PromptContainer>
              <RowLayout
                style={{ alignItems: 'center', gap: 12, marginBottom: 16 }}
              >
                <ColumnLayout>
                  <H2>📄</H2>
                </ColumnLayout>
                <ColumnLayout>
                  <Body1
                    style={{
                      fontWeight: 'bold',
                      color: '#606060',
                      lineHeight: 20,
                      marginBottom: 4,
                    }}
                  >
                    보내주시는 의견 하나 하나 꼼꼼히 읽고 있어요.{'\n'}좋았던
                    점, 아쉬운 점 무엇이든 알려주세요!
                  </Body1>
                  <Body2 style={{ color: '#606060' }}>
                    🌟 신규 카테고리 신청도 받고 있어요
                  </Body2>
                </ColumnLayout>
              </RowLayout>
              <PromptInput
                // @ts-ignore
                ref={inputRef}
                value={inputText}
                onChangeText={setInputText}
              />
              <ButtonRow>
                <Button
                  title='보내기'
                  onPress={() => onConfirm(inputText, setInputText)}
                  buttonStyle={{
                    backgroundColor: '#393939',
                    borderWidth: 0,
                    paddingTop: 14,
                    paddingBottom: 14,
                    paddingLeft: 34.5,
                    paddingRight: 34.5,
                    borderTopRightRadius: 999,
                    borderTopLeftRadius: 999,
                    borderBottomRightRadius: 999,
                    borderBottomLeftRadius: 999,
                    ...ButtonShadow,
                  }}
                  textStyle={{ color: colors.white }}
                />
              </ButtonRow>
            </PromptContainer>
          </TouchableWithoutFeedback>
        </ModalBackground>
      </TouchableWithoutFeedback>
    </Modal>
  )
}

const ModalBackground = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 0 20px;
`

const PromptContainer = styled(ColumnLayout)`
  width: 100%;
  padding: 24px 20px;
  background-color: #f1f1f1;
  border-radius: 20px;
`

const PromptInput = styled(CustomTextInput)`
  height: 40px;
  background-color: ${colors.white};
  border-radius: 16px;
  margin-bottom: 20px;
  padding: 0 10px;
`

const ButtonRow = styled(RowLayout)`
  justify-content: center;
`
